import React, { useState } from "react";
import { BASE_URL, API_KEY } from "./config";
import "./FeedbackModal.css";

const FeedbackModal = ({ onClose, sourcePage }) => {
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");

  const submitFeedback = async () => {
    if (!message.trim()) {
      alert("Please enter feedback");
      return;
    }

    await fetch(`${BASE_URL}/api/bot/ui/feedback/public`, {
      method: "POST",
      headers: { "Content-Type": "application/json" ,
                          "X-SIGNALFLY-KEY": API_KEY },
      body: JSON.stringify({
        email,
        message,
        sourcePage,
      }),
    });

    alert("Thanks for your feedback!");
    onClose();
  };

  return (
    <div className="feedback-modal-overlay">
      <div className="feedback-modal-content">
        <div className="feedback-modal-header">
          <div>
            <span className="feedback-eyebrow">SignalFly Feedback</span>
            <h3>Share Feedback</h3>
            <p>Tell us what should be clearer, faster, or easier in your trading workflow.</p>
          </div>
          <button className="feedback-close-btn" onClick={onClose} type="button">
            X
          </button>
        </div>

        <div className="feedback-field-grid">
          <label>
            <span>Email optional</span>
            <input
              type="email"
              placeholder="name@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </label>

          <label>
            <span>Feedback</span>
            <textarea
              placeholder="Feature idea, issue, confusing screen, missing signal detail..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
          </label>
        </div>

        <div className="feedback-modal-actions">
          <button className="feedback-submit-btn" onClick={submitFeedback}>Submit Feedback</button>
          <button className="feedback-cancel-btn" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default FeedbackModal;
